/**
 * What one bulk-run item counts as, the same rule the backend's readiness applies: a person's mark
 * decides a settled reply over the judge, and a reply nobody could judge waits for one.
 */

import type { BulkRunItem } from '@/types/websocket.types';

export type ItemOutcome = 'passed' | 'flagged' | 'incorrect' | 'failed' | 'unjudged' | 'pending';

/** The judge's worst bucket: a hard failure. */
const HARD_FAIL_BUCKET = 'Incorrect';

export const itemOutcome = (
	item: Pick<BulkRunItem, 'status' | 'bucket' | 'flagged' | 'comparisonError' | 'review'>
): ItemOutcome => {
	if (item.status === 'failed') return 'failed';
	if (item.status !== 'done') return 'pending';
	if (item.review) return item.review.verdict === 'correct' ? 'passed' : 'incorrect';
	if (item.bucket === null || item.comparisonError) return 'unjudged';
	if (item.bucket === HARD_FAIL_BUCKET) return 'incorrect';
	return item.flagged ? 'flagged' : 'passed';
};
